import React from 'react';
import { alpha, Box } from '@mui/material';
import { format } from 'date-fns/format';
import useBundleTranslation from 'i18n';
import { UserAuth } from 'store/auth';
import { useAppSelector } from 'store/hooks';

export default function MenuAbout() {
    const { t } = useBundleTranslation();
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const projectVersion = userAuth.configuration.constants.PROJECT_VERSION;
    const packageDate = userAuth.configuration.constants?.PACKAGE_DATE;
    const formattedDate = React.useMemo(() => {
        if (!packageDate) {
            return '';
        }
        const parsedDate = new Date(packageDate);
        if (Number.isNaN(parsedDate.getTime())) {
            return '';
        }
        return format(parsedDate, 'MMM d, y');
    }, [packageDate]);

    return (
        <Box sx={{ px: 1 }}>
            <Box sx={{ py: 0.5 }}>
                {t('version')} <Box component={'strong'}>{projectVersion}</Box>
            </Box>
            <Box sx={{ py: 0.5 }}>
                <Box sx={{ color: (theme) => alpha(theme.palette.text.primary, 0.64) }}>{t('released_on')}</Box>
                {formattedDate && <Box>{formattedDate}</Box>}
            </Box>
        </Box>
    );
}
